/* unplugin-vue-components disabled */import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/quanxuan.png';
import _imports_1 from '@/assets/images/quxiaoquanxuan.png';
const _hoisted_1 = {
  class: "userbody"
};
const _hoisted_2 = {
  class: "userinfo"
};
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_5 = {
  class: "info"
};
import { addorupdateprojectreportno } from "@/api/base/project";
export default {
  __name: 'add',
  setup(__props, {
    expose: __expose
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const getMessage = inject("getMessage");
    const visible = ref(false);
    const selectedAll = ref(false);
    const projectId = ref(undefined);
    const projectName = ref(undefined);
    const reportLevel = ref(undefined);
    const reportColor = ref(undefined);
    const title = ref("");
    const alarmTypes = ref([]);
    const alarmTypeSelect = ref([]);
    function getTitle() {
      if (reportLevel.value === 1) {
        title.value = projectName.value + "：一级告警";
      } else if (reportLevel.value === 2) {
        title.value = projectName.value + "：二级告警";
      } else if (reportLevel.value === 3) {
        title.value = projectName.value + "：三级告警";
      } else if (reportLevel.value === 4) {
        title.value = projectName.value + "：四级告警";
      }
    }
    function getshow(id, name, level, color, defaultlist, selectlist) {
      projectId.value = id;
      projectName.value = name;
      reportLevel.value = level;
      reportColor.value = color;
      getTitle();
      alarmTypes.value = [];
      selectedAll.value = false;
      alarmTypeSelect.value = [];
      if (selectlist.length > 0) {
        selectlist.map(item => {
          if (item.projectId === id) {
            alarmTypeSelect.value.push(item);
          }
        });
      }
      if (alarmTypeSelect.value.length > 0) {
        alarmTypeSelect.value.forEach(item => {
          if (item.reportLevel !== level) {
            alarmTypes.value = defaultlist.map(tmp => {
              if (item.type === tmp.type) {
                tmp.disabled = true;
                tmp.selected = true;
              }
              return tmp;
            });
          } else {
            alarmTypes.value = defaultlist.map(tmp => {
              if (item.type === tmp.type) {
                tmp.selected = true;
                tmp.disabled = false;
              }
              return tmp;
            });
          }
        });
      } else {
        alarmTypes.value = defaultlist.map(item => {
          item.selected = false;
          item.disabled = false;
          return item;
        });
      }
      visible.value = true;
    }
    function checkOn(item) {
      return item.disabled;
    }
    function getSelected() {
      selectedAll.value = !selectedAll.value;
      getSelectedCheck();
    }
    function getSelectedCheck() {
      var data = alarmTypes.value;
      for (var i = 0; i < data.length; i++) {
        if (!data[i].disabled) {
          data[i].selected = selectedAll.value;
        }
      }
      alarmTypes.value = data;
      updataWorkConfig();
    }
    // 判断是否全选
    function getIsSeletedAll() {
      var data = alarmTypes.value;
      selectedAll.value = false;
      var num = 0;
      data.forEach(type => {
        if (type.selected) {
          num = num + 1;
        }
      });
      if (num === alarmTypes.value.length && alarmTypes.value.length > 0) {
        selectedAll.value = true;
      }
      updataWorkConfig();
    }
    // 选择
    function selected(e) {
      alarmTypes.value[e].selected = !alarmTypes.value[e].selected;
      // 更新列表
      proxy.$forceUpdate();
      getIsSeletedAll();
    }
    function updataWorkConfig() {
      let types = '';
      alarmTypes.value.forEach(type => {
        if (!type.disabled && type.selected) {
          types += type.type + ',';
        }
      });
      console.log(alarmTypes.value);
      let formData = {
        projectId: projectId.value,
        reportLevel: reportLevel.value,
        reportColor: reportColor.value,
        types: types
      };
      addorupdateprojectreportno(JSON.stringify(formData)).then(response => {
        proxy.$forceUpdate();
        getMessage();
      });
    }
    __expose({
      getshow
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: _unref(title),
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "80rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[1] || (_cache[1] = $event => visible.value = false),
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "quanxuan",
          onClick: getSelected
        }, [_unref(selectedAll) ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), !_unref(selectedAll) ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("span", null, "全选/全不选", -1))]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alarmTypes), (item, index) => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            onChange: getIsSeletedAll,
            modelValue: item.selected,
            "onUpdate:modelValue": $event => item.selected = $event,
            key: index,
            label: item.reportName,
            disabled: checkOn(item)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]);
        }), 128))])])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};